module.exports = __webpack_public_path__ + "img/max-file-sync--pdf.1dd522ac.svg";